export default __webpack_public_path__ + "static/media/meal3.e09a78ce.svg";